const PRINCIPAL_TYPE = {
    TEAM: 'TEAM',
    USER: 'USER',
    ORG: 'ORG',
};

export default PRINCIPAL_TYPE;
